"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overflow = void 0;
require("./overflow.css");
const overflow = {
  hidden: "cds-hidden-h1op4l4w",
  scroll: "cds-scroll-s1d7uwzn",
  visible: "cds-visible-v10j5mk2",
  auto: "cds-auto-a2deryr",
  clip: "cds-clip-c1xm4zr0"
};
exports.overflow = overflow;